export const ProductContext = {
    LUBES: 'LUBES',
} as const;

// eslint-disable-next-line no-redeclare
export type ProductContext = keyof typeof ProductContext;
